/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

/**
 * Dedicated type for plugin name/id that is supposed to make Map/Set/Arrays
 * that use it as a key or value more obvious.
 *
 * @public
 */

/** @public */

/** @public */
export let PluginType = /*#__PURE__*/function (PluginType) {
  PluginType["preboot"] = "preboot";
  PluginType["standard"] = "standard";
  return PluginType;
}({});

/**
 * Small container object used to expose information about discovered plugins that may
 * or may not have been started.
 * @public
 */